import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaUserCog, FaProjectDiagram, FaRegChartBar, FaPowerOff } from 'react-icons/fa';
import './styles/sidebar.css';

const Sidebar = () => {
  return (
    <div className="sidebar-container">
      <div className="sidebar-logo">
        <h2>Dashboard</h2>
      </div>
      <div className="sidebar-menu">
        <ul>
          <li>
            <Link to="/dashboard" className="sidebar-link">
              <FaHome className="sidebar-icon" />
              <span className="link-text">Accueil</span>
            </Link>
          </li>
          <li>
            <Link to="/dashboard/manage-users" className="sidebar-link">
              <FaUserCog className="sidebar-icon" />
              <span className="link-text">Gestion Utilisateurs</span>
            </Link>
          </li>
          <li>
            <Link to="/dashboard/projects" className="sidebar-link">
              <FaProjectDiagram className="sidebar-icon" />
              <span className="link-text">Projets</span>
            </Link>
          </li>
          <li>
            <Link to="/dashboard/statistics" className="sidebar-link">
              <FaRegChartBar className="sidebar-icon" />
              <span className="link-text">Statistiques</span>
            </Link>
          </li>
          <li>
            <Link to="/logout" className="sidebar-link">
              <FaPowerOff className="sidebar-icon" />
              <span className="link-text">Se Déconnecter</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
